import "@/RightHire.css";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Footer, SiteHeader } from "@/components/SiteHeader";
import AboutPhotoPage from "@/pages/AboutPhotoPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import CandidatePortalPage from "@/pages/CandidatePortalPage";
import ContactPage from "@/pages/ContactPage";
import EmployersPage from "@/pages/EmployersPage";
import HomePage from "@/pages/HomePage";
import IndustriesPage from "@/pages/IndustriesPage";
import JobSeekersSecurePage from "@/pages/JobSeekersSecurePage";
import LoginPage from "@/pages/LoginPage";
import VacanciesPage from "@/pages/VacanciesPage";

const PublicLayout = ({ children }) => (
  <>
    <SiteHeader />
    {children}
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    document.title = "Right Hire Personnel | Adelaide Labour Hire";
  }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
      <Routes>
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPhotoPage /></PublicLayout>} />
        <Route path="/employers" element={<PublicLayout><EmployersPage /></PublicLayout>} />
        <Route path="/job-seekers" element={<PublicLayout><JobSeekersSecurePage /></PublicLayout>} />
        <Route path="/vacancies" element={<PublicLayout><VacanciesPage /></PublicLayout>} />
        <Route path="/industries" element={<PublicLayout><IndustriesPage /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<ProtectedRoute roles={["admin", "recruiter"]}><AdminDashboardPage /></ProtectedRoute>} />
        <Route path="/candidate-portal" element={<ProtectedRoute roles={["candidate"]}><CandidatePortalPage /></ProtectedRoute>} />
      </Routes>
      </AuthProvider>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}

export default App;
